module.exports = __webpack_public_path__ + "img/truck-arrow-right-solid.3dfc467f.svg";